export default __webpack_public_path__ + "static/media/logow.55513742.svg";